


































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { SchoolGroupCompetencyRanking } from '@/models/school-group/school-group-competency-ranking';
import GCompetencyHeader from '@/components/GCompetencyHeader.vue';

@Component({
  name: 'GClassManagementCompetencyRankCard',
  components: { GCompetencyHeader },
  computed: {},
  methods: {},
})
export default class GClassManagementCompetencyRankCard extends mixins(GPageBase) {
  @Prop() competencyRank: SchoolGroupCompetencyRanking;

  mounted() {}

  getGradeAndSchoolClassNameFullName(index: number): string {
    return `${this.competencyRank.ranking[index].gradeAndSchoolClassName} ${this.competencyRank.ranking[index].studentName}`;
  }

  getLinkToKarte(index: number): string {
    const url = this.$router.resolve({
      name: 'student-record',
      params: { studentID: this.competencyRank.ranking[index].studentID.toString() }
    }).href
    return url;
  }
}
